<template>
    <b-row>
        <b-col v-for="(col,index) in data.columns" :key="`columna-${index}`">
            <slot v-if="col.element">
                <component :is="col.element.tag" v-bind="{data: col.element}"></component>
            </slot>
        </b-col>
    </b-row>
</template>
<style lang="scss" scoped>
</style>
<script>
import Recurso from './Recurso';
import Tabla from './Tabla';
import Parrafo from './Parrafo';
import Columnas from './Columnas';
import QuizContent from './QuizContent';
export default {
    name:'pre-columnas',
    components: {
        Recurso,
        Parrafo,
        Tabla,
        Columnas,
        QuizContent
    },
    props: {
        data: {
            type:Object,
            default: () => {
                return {
                    index: null,
                    tag: 'Columnas',
                    columns: []
                }
            }
        }
    }
}
</script>